/* Keep the beige product panel starting just above the little feature icons (desktop),
   so the icons never straddle the panel's top edge, whatever the screen width. */
(function () {
  function align() {
    var warp = document.querySelector('.product-warp');
    if (!warp) return;
    var icons = warp.querySelector('.product__info-container .icon-with-text--vertical, .product__info-wrapper .icon-with-text--vertical');
    if (!icons || window.innerWidth < 990) { warp.style.removeProperty('--panel-x'); return; }
    var top = icons.getBoundingClientRect().top - warp.getBoundingClientRect().top;
    warp.style.setProperty('--panel-x', Math.max(120, Math.round(top - 26)) + 'px');
  }
  function start() {
    align();
    window.addEventListener('resize', align);
    window.addEventListener('load', align);
    if ('ResizeObserver' in window) {
      var info = document.querySelector('.product__info-wrapper, .product__info-container');
      if (info) new ResizeObserver(align).observe(info);
    }
    setTimeout(align, 800);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
